import { PhoneApps } from '~/shared';
import ads from '../assets/icons/apps/ads.png';
import bank from '../assets/icons/apps/bank.png';
import camera from '../assets/icons/apps/camera.png';
import contacts from '../assets/icons/apps/contacts.png';
import gps from '../assets/icons/apps/gps.png';
import messenger from '../assets/icons/apps/messenger.png';
import phone from '../assets/icons/apps/phone.png';
import photos from '../assets/icons/apps/photos.png';
import settings from '../assets/icons/apps/settings.png';

export const appsIcons = {
	[PhoneApps.MAIN]: '',
	[PhoneApps.MESSENGER]: messenger,
	[PhoneApps.CAMERA]: camera,
	[PhoneApps.GPS]: gps,
	[PhoneApps.BANK]: bank,
	[PhoneApps.SETTINGS]: settings,
	[PhoneApps.CONTACTS]: contacts,
	[PhoneApps.PHONE]: phone,
	[PhoneApps.PHOTOS]: photos,
	[PhoneApps.ADS]: ads,
};

export const appsNames = {
	[PhoneApps.MAIN]: '',
	[PhoneApps.MESSENGER]: 'Сообщения',
	[PhoneApps.CAMERA]: 'Камера',
	[PhoneApps.GPS]: 'Навигатор',
	[PhoneApps.BANK]: 'Банк',
	[PhoneApps.SETTINGS]: 'Настройки',
	[PhoneApps.CONTACTS]: 'Контакты',
	[PhoneApps.PHONE]: 'Телефон',
	[PhoneApps.PHOTOS]: 'Фото',
	[PhoneApps.ADS]: 'Объявления',
};

export const mainApps = [
	// PhoneApps.PHONE,
	PhoneApps.MESSENGER,
	// PhoneApps.CONTACTS,
	// PhoneApps.PHOTOS,
	PhoneApps.BANK,
	PhoneApps.GPS,
	PhoneApps.CAMERA,
	PhoneApps.ADS,
	PhoneApps.SETTINGS,
];
